import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=5d8a5d32&scoped=true"
import script from "./RouterView.vue?vue&type=script&lang=js"
export * from "./RouterView.vue?vue&type=script&lang=js"
import style0 from "./RouterView.vue?vue&type=style&index=0&id=5d8a5d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a5d32",
  null
  
)

export default component.exports